import { useNavigate } from "react-router-dom";

import { VerifierSingleCardTemplate } from "../../../../../templates";
import { getUserSettingsRoute } from "../../../../../utils/routes";
import { EditForm } from "../../../../shared";
import { useEdit } from "./useEdit";

export const Edit = (): JSX.Element => {
  const navigate = useNavigate();
  const { pageTitle, dataIsLoading, userDetails, userUuid, roles, rolesInfo, currentUserType } = useEdit();

  return (
    <div>
      {!dataIsLoading && (
        <VerifierSingleCardTemplate
          activeElement="Settings"
          pageTitle={pageTitle}
          handleBackClick={() => navigate(getUserSettingsRoute(currentUserType))}
          backButtonText="Back to users"
        >
          {userDetails && (
            <EditForm
              userUuid={userUuid}
              defaultRoleValue={userDetails.role}
              defaultActiveValue={userDetails.active}
              firstName={userDetails.user.firstName}
              lastName={userDetails.user.lastName}
              email={userDetails.user.email}
              roles={roles}
              rolesInfo={rolesInfo}
              rowVersion={userDetails.rowVersion}
              userSettingsRoute={getUserSettingsRoute(currentUserType)}
            />
          )}
        </VerifierSingleCardTemplate>
      )}
    </div>
  );
};
